import { render, staticRenderFns } from "./newOaWorkflowList.vue?vue&type=template&id=082adb2a&scoped=true"
import script from "./newOaWorkflowList.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowList.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowList.vue?vue&type=style&index=0&id=082adb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082adb2a",
  null
  
)

export default component.exports